import script from "./PlantaLote.vue?vue&type=script&setup=true&lang=js"
export * from "./PlantaLote.vue?vue&type=script&setup=true&lang=js"

import "./PlantaLote.vue?vue&type=style&index=0&id=63a0049c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63a0049c"]])

export default __exports__